export function getLinksFromMarkdown(markdownText: string) {
  const regex = /(\[[^\]]+\]\((?:(?!\)).)+\))|(\n)/g;
  const parts = [];
  let lastIndex = 0;

  markdownText.replace(regex, (match, p1, p2, offset) => {
    if (lastIndex < offset) {
      parts.push({
        type: 'text',
        content: markdownText.substring(lastIndex, offset),
        text: '',
        url: '',
      });
    }

    if (p1) {
      const textRegex = p1.match(/\[(.*?)\]/);
      const linkRegex = p1.match(/\((.*?)\)/);

      if (textRegex && linkRegex) {
        parts.push({ type: 'link', content: '', text: textRegex[1], url: linkRegex[1] });
      }
    } else if (p2) {
      parts.push({ type: 'break', content: '', text: '', url: '' });
    }

    lastIndex = offset + match.length;
    return match;
  });

  if (lastIndex < markdownText.length) {
    parts.push({ type: 'text', content: markdownText.substring(lastIndex), text: '', url: '' });
  }

  return parts;
}
